import React from 'react';
import Chip from '@mui/material/Chip';

// Helper to map payment method code to color
export function getPaymentMethodColor(code: string) {
  switch (code) {
    case 'CASH': return '#4caf50'; // green
    case 'CARD': return '#2196f3'; // blue
    case 'INSURANCE': return '#ff9800'; // orange
    case 'CHEQUE': return '#9c27b0'; // purple
    default: return '#607d8b'; // grey
  }
}

interface ChipPaymentMethodProps {
  code: string;
  label: string;
  size?: 'small' | 'medium';
  style?: React.CSSProperties;
}

const ChipPaymentMethod: React.FC<ChipPaymentMethodProps> = ({ code, label, size = 'small', style }) => (
  <Chip
    label={label}
    size={size}
    style={{ backgroundColor: getPaymentMethodColor(code), color: '#fff', ...style }}
  />
);

export default ChipPaymentMethod; 